module.exports = __webpack_public_path__ + "img/elec_bottom3_s.5b6a5fe1.png";